module.exports = __webpack_public_path__ + "img/mail.66593c4e.svg";